export default __webpack_public_path__ + "static/media/air-photos-primary-icon.68e8407b.svg";